import { Swiper } from './swiper-DDnfT8S0.js';
import { P as Pagination } from './pagination-BF_S6uBm.js';
import { A as A11y } from './a11y-DMhWZZ38.js';
import { S as SwiperExt } from './swiper-BAqQR4kf.js';
import './utils-CPPFXbqB.js';
import './create-element-if-not-defined-BweCirD8.js';

class ProductCard extends SwiperExt {
  connectedCallback() {
    const swiperEl = this.querySelector('.swiper');
    if (!swiperEl) return;
    const nestedSwiper = this.dataset.nestedSwiper === 'true';
    this.swiperInstance = new Swiper(swiperEl, {
      modules: [A11y, Pagination],
      spaceBetween: 0,
      loop: false,
      slidesPerView: 1,
      simulateTouch: false,
      nested: nestedSwiper,
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  }
}

customElements.define('product-card', ProductCard);
